export default __webpack_public_path__ + "static/media/klaus_s.ae14c95f.jpg";